<div class="side-sheet side-sheet-details" [ngClass]="{'active': selectedRecordId}">
  <div class="d-flex h-100">

    <div class="overlay" (click)="close.emit()"></div>

    <div class="sheet-container">
      <div class="sheet-head d-block p-0">
        <div class="head">
          <div class="title">
            {{'productEvaluationTasks.productEvaluationResult' | translate}}
          </div>
          <a (click)="close.emit()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
              <path id="ic_close"
                d="M213.746-744.393l-6.441,6.436a1.459,1.459,0,0,1-1.063.457,1.406,1.406,0,0,1-1.046-.457,1.418,1.418,0,0,1-.45-1.054,1.449,1.449,0,0,1,.45-1.037l6.441-6.452-6.441-6.452a1.419,1.419,0,0,1-.441-1.037,1.473,1.473,0,0,1,.441-1.053,1.406,1.406,0,0,1,1.046-.457,1.485,1.485,0,0,1,1.063.441l6.441,6.452,6.458-6.452a1.431,1.431,0,0,1,1.046-.441,1.458,1.458,0,0,1,1.063.457,1.443,1.443,0,0,1,.433,1.053,1.448,1.448,0,0,1-.45,1.037l-6.441,6.452,6.441,6.452a1.419,1.419,0,0,1,.441,1.037,1.473,1.473,0,0,1-.441,1.054,1.406,1.406,0,0,1-1.046.457,1.406,1.406,0,0,1-1.046-.457Z"
                transform="translate(-204.746 755.5)" fill="#8e8fa2" />
            </svg>
          </a>
        </div>
      </div>
      <ng-container *ngIf="!dataLoading">
        <div class="sheet-top-info mb-0">
          <div class="conatiner_has_avatar">
            <div class="image_circle w_60 square">
              <div class="image">
                <img *ngIf="details.productImage" [src]="details.productImage"
                  (error)='details.productImage = "assets/images/product_no_logo.png"'>
              </div>
            </div>
            <div class="name">
              <h5 class="m-0">{{details.productName}}</h5>
            </div>
          </div>
        </div>
        <div class="sheet-content">
          <div class="row">
            <div class="col-md-5 col-sm-12 mb-4">
              <div class="item_count_grey w-100">
                <span class="item_label">
                  {{'productEvaluationTasks.overallProductEvaluation' | translate}}:
                </span>
                <p class="item_value">
                  {{details.totalScore}}%
                </p>
              </div>
            </div>
            <div class="col-md-7 col-sm-12 mb-4">
              <div class="date_time_date w-100">
                <span>
                  {{'productEvaluationTasks.evaluationResultEntryDate' | translate}}
                </span>
                <p>
                  {{details.submittedAt| date:'d MMM yyyy - h:mm a'}}
                </p>
              </div>
            </div>
          </div>
          <h5 class="title_has_count">
            <strong>
              {{details.criteriaCount}}
            </strong> {{'productEvaluationTasks.criteria' | translate}}
          </h5>

          @if (details.criterias && details.criterias.length) {
          @for (question of details.criterias; track question.id) {
          <div class="card_queestion_answer">
            <h6 class="card_title">
              @switch (question.technicalCriteriaAnswerTypeCode) {
              @case (criteriaAnswerTypeCode.Numeric) {
              <img src="./assets/images/icons/numbers_ic.png" alt="">
              }
              @case (criteriaAnswerTypeCode.Percentage) {
              <img src="./assets/images/icons/percent_ic.png" alt="">
              }
              @case (criteriaAnswerTypeCode.Star_Rating) {
              <img src="./assets/images/icons/starRating.png" alt="">
              }
              }
              {{question.technicalCriteriaAnswerTypeName}}


            </h6>
            <p class="card_description">
              {{question.name}}
            </p>
            @if (question.answerValue) {
            <h6 class="card_title">
              <span class="card_badge">
                {{"evaluationTasks.answer"|translate}}
              </span>
            </h6>
            }
            @if (question.answerValue && question.technicalCriteriaAnswerTypeCode != criteriaAnswerTypeCode.Star_Rating)
            {
            @if(question.technicalCriteriaAnswerTypeCode === criteriaAnswerTypeCode.Percentage) {

            <p class="card_description text-answer" dir="ltr">
              %{{question.answerValue}}
            </p>
            } @else {
            <p class="card_description text-answer">
              {{question.answerValue}}
            </p>

            }
            }
            @if (question.answerValue && question.technicalCriteriaAnswerTypeCode == criteriaAnswerTypeCode.Star_Rating)
            {
            <p class="card_description text-answer">
              <strong>{{question.starRateEnum}}</strong>
              {{"general.from" |translate}}
              <strong>5</strong>
            </p>
            }
            @if (question.starRateEnum)
            {
            <p class="card_description">
              <span class="star_rating blue">
                <mat-icon *ngFor="let star of [1,2,3,4,5]" class="star_icon "
                  [class.filled]="star <= (question.starRateEnum || 0)">
                  {{ star <= (question.starRateEnum || 0) ? 'star' : 'star_border' }} </mat-icon>
              </span>
            </p>
            }
            @if (question.attachmentUrls && question.attachmentUrls.length)
            {
            <p class="card_description">
              <app-files-viewer [files]="question.attachmentUrls"></app-files-viewer>
            </p>
            }
            <p class="card_description">
              <span class="badge-status light">
                <span>{{"productEvaluationTasks.criteriaWeightBasedOnAnswer" | translate}} :</span> {{
                question.weightedScore}} %
              </span>
            </p>
          </div>
          }

          }
        </div>
      </ng-container>

      <div *ngIf='dataLoading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>
    </div>
  </div>
</div>
